export const occupations = [
  "accountant",
  "actor",
  "actuary",
  "adhesive bonding machine tender",
  "adjudicator",
  "administrative assistant",
  "administrative services manager",
  "adult education teacher",
  "advertising manager",
  "advertising sales agent",
  "aerobics instructor",
  "aerospace engineer",
  "aerospace engineering technician",
  "agent",
  "agricultural engineer",
  "agricultural equipment operator",
  "agricultural grader",
  "agricultural inspector",
  "agricultural manager",
  "agricultural sciences teacher",
  "agricultural sorter",
  "agricultural technician",
  "agricultural worker",
  "air conditioning installer",
  "air conditioning mechanic",
  "air traffic controller",
  "aircraft cargo handling supervisor",
  "aircraft mechanic",
  "aircraft service technician",
  "airline copilot",
  "airline pilot",
  "ambulance dispatcher",
  "ambulance driver",
  "amusement machine servicer",
  "anesthesiologist",
  "animal breeder",
  "animal control worker",
  "animal scientist",
  "animal trainer",
  "animator",
  "answering service operator",
  "anthropologist",
  "apparel patternmaker",
  "apparel worker",
  "arbitrator",
  "archeologist",
  "architect",
  "architectural drafter",
  "architectural manager",
  "archivist",
  "art director",
  "art teacher",
  "artist",
  "assembler",
  "astronomer",
  "athlete",
  "athletic trainer",
  "ATM machine repairer",
  "atmospheric scientist",
  "attendant",
  "audio and video equipment technician",
  "audio-visual and multimedia collections specialist",
  "audiologist",
  "auditor",
  "author",
  "auto damage insurance appraiser",
  "automotive and watercraft service attendant",
  "automotive glass installer",
  "automotive mechanic",
  "avionics technician",
  "back-end developer",
  "baggage porter",
  "bailiff",
  "baker",
  "barback",
  "barber",
  "bartender",
  "basic education teacher",
  "behavioral disorder counselor",
  "bellhop",
  "bench carpenter",
  "bicycle repairer",
  "bill and account collector",
  "billing and posting clerk",
  "biochemist",
  "biological technician",
  "biomedical engineer",
  "biophysicist",
  "blaster",
  "blending machine operator",
  "blockmason",
  "boiler operator",
  "boilermaker",
  "bookkeeper",
  "boring machine tool tender",
  "brazer",
  "brickmason",
  "bridge and lock tender",
  "broadcast news analyst",
  "broadcast technician",
  "brokerage clerk",
  "budget analyst",
  "building inspector",
  "bus mechanic",
  "butcher",
  "buyer",
  "cabinetmaker",
  "cafeteria attendant",
  "cafeteria cook",
  "camera operator",
  "camera repairer",
  "cardiovascular technician",
  "cargo agent",
  "carpenter",
  "carpet installer",
  "cartographer",
  "cashier",
  "caster",
  "ceiling tile installer",
  "cellular equipment installer",
  "cement mason",
  "channeling machine operator",
  "chauffeur",
  "checker",
  "chef",
  "chemical engineer",
  "chemical plant operator",
  "chemist",
  "chemistry teacher",
  "chief executive",
  "child social worker",
  "childcare worker",
  "chiropractor",
  "choreographer",
  "civil drafter",
  "civil engineer",
  "civil engineering technician",
  "claims adjuster",
  "claims examiner",
  "claims investigator",
  "cleaner",
  "clinical laboratory technician",
  "clinical laboratory technologist",
  "clinical psychologist",
  "coating worker",
  "coatroom attendant",
  "coil finisher",
  "coil taper",
  "coil winder",
  "coin machine servicer",
  "commercial diver",
  "commercial pilot",
  "commodities sales agent",
  "communications equipment operator",
  "communications teacher",
  "community association manager",
  "community service manager",
  "compensation and benefits manager",
  "compliance officer",
  "composer",
  "computer hardware engineer",
  "computer network architect",
  "computer operator",
  "computer programmer",
  "computer science teacher",
  "computer support specialist",
  "computer systems administrator",
  "computer systems analyst",
  "concierge",
  "conciliator",
  "concrete finisher",
  "conservation science teacher",
  "conservation scientist",
  "conservation worker",
  "conservator",
  "construction inspector",
  "construction manager",
  "construction painter",
  "construction worker",
  "continuous mining machine operator",
  "convention planner",
  "conveyor operator",
  "cook",
  "cooling equipment operator",
  "copy marker",
  "correctional officer",
  "correctional treatment specialist",
  "correspondence clerk",
  "correspondent",
  "cosmetologist",
  "cost estimator",
  "costume attendant",
  "counseling psychologist",
  "counselor",
  "courier",
  "court reporter",
  "craft artist",
  "crane operator",
  "credit analyst",
  "credit checker",
  "credit counselor",
  "criminal investigator",
  "criminal justice teacher",
  "crossing guard",
  "curator",
  "custom sewer",
  "customer service representative",
  "cutter",
  "cutting machine operator",
  "dancer",
  "data entry keyer",
  "database administrator",
  "decorating worker",
  "delivery services driver",
  "demonstrator",
  "dental assistant",
  "dental hygienist",
  "dental laboratory technician",
  "dentist",
  "dermatologist",
  "derrick operator",
  "designer",
  "desktop publisher",
  "detective",
  "developer",
  "diagnostic medical sonographer",
  "die maker",
  "diesel engine specialist",
  "dietetic technician",
  "dietitian",
  "dinkey operator",
  "director",
  "dishwasher",
  "dispatcher",
  "DJ",
  "doctor",
  "door-to-door sales worker",
  "drafter",
  "dragline operator",
  "drama teacher",
  "dredge operator",
  "dressing room attendant",
  "dressmaker",
  "drier operator",
  "drilling machine tool operator",
  "dry-cleaning worker",
  "drywall installer",
  "dyeing machine operator",
  "earth driller",
  "economics teacher",
  "economist",
  "editor",
  "education administrator",
  "electric motor repairer",
  "electrical electronics drafter",
  "electrical engineer",
  "electrical equipment assembler",
  "electrical installer",
  "electrical power-line installer",
  "electrician",
  "electro-mechanical technician",
  "elementary school teacher",
  "elevator installer",
  "elevator repairer",
  "embalmer",
  "emergency management director",
  "emergency medical technician",
  "engine assembler",
  "engineer",
  "engineering manager",
  "engineering teacher",
  "english language teacher",
  "engraver",
  "entertainment attendant",
  "environmental engineer",
  "environmental science teacher",
  "environmental scientist",
  "epidemiologist",
  "escort",
  "etcher",
  "event planner",
  "excavating operator",
  "executive administrative assistant",
  "executive secretary",
  "exhibit designer",
  "expediting clerk",
  "explosives worker",
  "extraction worker",
  "fabric mender",
  "fabric patternmaker",
  "fabricator",
  "faller",
  "family practitioner",
  "family social worker",
  "family therapist",
  "farm advisor",
  "farm equipment mechanic",
  "farm labor contractor",
  "farmer",
  "farmworker",
  "fashion designer",
  "fast food cook",
  "fence erector",
  "fiberglass fabricator",
  "fiberglass laminator",
  "file clerk",
  "filling machine operator",
  "film and video editor",
  "financial analyst",
  "financial examiner",
  "financial manager",
  "financial services sales agent",
  "fine artist",
  "fire alarm system installer",
  "fire dispatcher",
  "fire inspector",
  "fire investigator",
  "firefighter",
  "fish and game warden",
  "fish cutter",
  "fish trimmer",
  "fisher",
  "fitness studies teacher",
  "fitness trainer",
  "flight attendant",
  "floor finisher",
  "floor layer",
  "floor sander",
  "floral designer",
  "food batchmaker",
  "food cooking machine operator",
  "food preparation worker",
  "food science technician",
  "food scientist",
  "food server",
  "food service manager",
  "food technologist",
  "foreign language teacher",
  "foreign literature teacher",
  "forensic science technician",
  "forest fire inspector",
  "forest fire prevention specialist",
  "forest worker",
  "forester",
  "forestry teacher",
  "forging machine setter",
  "foundry coremaker",
  "freight agent",
  "freight mover",
  "front-end developer",
  "fundraising manager",
  "funeral attendant",
  "funeral director",
  "funeral service manager",
  "furnace operator",
  "furnishings worker",
  "furniture finisher",
  "gaming booth cashier",
  "gaming cage worker",
  "gaming change person",
  "gaming dealer",
  "gaming investigator",
  "gaming manager",
  "gaming surveillance officer",
  "garment mender",
  "garment presser",
  "gas compressor",
  "gas plant operator",
  "gas pumping station operator",
  "general manager",
  "general practitioner",
  "geographer",
  "geography teacher",
  "geological engineer",
  "geological technician",
  "geoscientist",
  "glazier",
  "government program eligibility interviewer",
  "graduate teaching assistant",
  "graphic designer",
  "groundskeeper",
  "groundskeeping worker",
  "gynecologist",
  "hairdresser",
  "hairstylist",
  "hand grinding worker",
  "hand laborer",
  "hand packager",
  "hand packer",
  "hand polishing worker",
  "hand sewer",
  "hazardous materials removal worker",
  "head cook",
  "health and safety engineer",
  "health educator",
  "health information technician",
  "health services manager",
  "health specialties teacher",
  "healthcare social worker",
  "hearing officer",
  "heat treating equipment setter",
  "heating installer",
  "heating mechanic",
  "heavy truck driver",
  "highway maintenance worker",
  "historian",
  "history teacher",
  "hoist and winch operator",
  "home appliance repairer",
  "home economics teacher",
  "home entertainment installer",
  "home health aide",
  "home management advisor",
  "host",
  "hostess",
  "hostler",
  "hotel desk clerk",
  "housekeeping cleaner",
  "human resources assistant",
  "human resources manager",
  "human service assistant",
  "hunter",
  "hydrologist",
  "illustrator",
  "industrial designer",
  "industrial engineer",
  "industrial engineering technician",
  "industrial machinery mechanic",
  "industrial production manager",
  "industrial truck operator",
  "industrial-organizational psychologist",
  "information clerk",
  "information research scientist",
  "information security analyst",
  "information systems manager",
  "inspector",
  "instructional coordinator",
  "instructor",
  "insulation worker",
  "insurance claims clerk",
  "insurance sales agent",
  "insurance underwriter",
  "intercity bus driver",
  "interior designer",
  "internist",
  "interpreter",
  "interviewer",
  "investigator",
  "jailer",
  "janitor",
  "jeweler",
  "judge",
  "judicial law clerk",
  "kettle operator",
  "kiln operator",
  "kindergarten teacher",
  "laboratory animal caretaker",
  "landscape architect",
  "landscaping worker",
  "lathe setter",
  "laundry worker",
  "law enforcement teacher",
  "law teacher",
  "lawyer",
  "layout worker",
  "leather worker",
  "legal assistant",
  "legal secretary",
  "legislator",
  "librarian",
  "library assistant",
  "library science teacher",
  "library technician",
  "licensed practical nurse",
  "licensed vocational nurse",
  "life scientist",
  "lifeguard",
  "light truck driver",
  "line installer",
  "literacy teacher",
  "literature teacher",
  "loading machine operator",
  "loan clerk",
  "loan interviewer",
  "loan officer",
  "lobby attendant",
  "locker room attendant",
  "locksmith",
  "locomotive engineer",
  "locomotive firer",
  "lodging manager",
  "log grader",
  "logging equipment operator",
  "logistician",
  "machine feeder",
  "machinist",
  "magistrate judge",
  "magistrate",
  "maid",
  "mail clerk",
  "mail machine operator",
  "mail superintendent",
  "maintenance painter",
  "maintenance worker",
  "makeup artist",
  "management analyst",
  "manicurist",
  "manufactured building installer",
  "mapping technician",
  "marble setter",
  "marine engineer",
  "marine oiler",
  "market research analyst",
  "marketing manager",
  "marketing specialist",
  "marriage therapist",
  "massage therapist",
  "material mover",
  "materials engineer",
  "materials scientist",
  "mathematical science teacher",
  "mathematical technician",
  "mathematician",
  "maxillofacial surgeon",
  "measurer",
  "meat cutter",
  "meat packer",
  "meat trimmer",
  "mechanical door repairer",
  "mechanical drafter",
  "mechanical engineer",
  "mechanical engineering technician",
  "mediator",
  "medical appliance technician",
  "medical assistant",
  "medical equipment preparer",
  "medical equipment repairer",
  "medical laboratory technician",
  "medical laboratory technologist",
  "medical records technician",
  "medical scientist",
  "medical secretary",
  "medical services manager",
  "medical transcriptionist",
  "meeting planner",
  "mental health counselor",
  "mental health social worker",
  "merchandise displayer",
  "messenger",
  "metal caster",
  "metal patternmaker",
  "metal pickling operator",
  "metal pourer",
  "metal worker",
  "metal-refining furnace operator",
  "metal-refining furnace tender",
  "meter reader",
  "microbiologist",
  "middle school teacher",
  "milling machine setter",
  "millwright",
  "mine cutting machine operator",
  "mine shuttle car operator",
  "mining engineer",
  "mining safety engineer",
  "mining safety inspector",
  "mining service unit operator",
  "mixing machine setter",
  "mobile heavy equipment mechanic",
  "mobile home installer",
  "model maker",
  "model",
  "molder",
  "mortician",
  "motel desk clerk",
  "motion picture projectionist",
  "motorboat mechanic",
  "motorboat operator",
  "motorboat service technician",
  "motorcycle mechanic",
  "movers",
  "multimedia artist",
  "museum technician",
  "music director",
  "music teacher",
  "musical instrument repairer",
  "musician",
  "natural sciences manager",
  "naval architect",
  "network systems administrator",
  "new accounts clerk",
  "news vendor",
  "nonfarm animal caretaker",
  "nuclear engineer",
  "nuclear medicine technologist",
  "nuclear power reactor operator",
  "nuclear technician",
  "nursing aide",
  "nursing instructor",
  "nursing teacher",
  "nutritionist",
  "obstetrician",
  "occupational health and safety specialist",
  "occupational health and safety technician",
  "occupational therapist",
  "occupational therapy aide",
  "occupational therapy assistant",
  "offbearer",
  "office clerk",
  "office machine operator",
  "operating engineer",
  "operations manager",
  "operations research analyst",
  "ophthalmic laboratory technician",
  "optician",
  "optometrist",
  "oral surgeon",
  "order clerk",
  "order filler",
  "orderly",
  "ordnance handling expert",
  "orthodontist",
  "orthotist",
  "outdoor power equipment mechanic",
  "oven operator",
  "packaging machine operator",
  "painter ",
  "painting worker",
  "paper goods machine setter",
  "paperhanger",
  "paralegal",
  "paramedic",
  "parking enforcement worker",
  "parking lot attendant",
  "parts salesperson",
  "paving equipment operator",
  "payroll clerk",
  "pediatrician",
  "pedicurist",
  "personal care aide",
  "personal chef",
  "personal financial advisor",
  "personal trainer",
  "pest control worker",
  "pesticide applicator",
  "pesticide handler",
  "pesticide sprayer",
  "petroleum engineer",
  "petroleum gauger",
  "petroleum pump system operator",
  "petroleum refinery operator",
  "petroleum technician",
  "pharmacist",
  "pharmacy aide",
  "pharmacy technician",
  "philosophy teacher",
  "photogrammetrist",
  "photographer",
  "photographic process worker",
  "photographic processing machine operator",
  "physical therapist aide",
  "physical therapist assistant",
  "physical therapist",
  "physician assistant",
  "physician",
  "physicist",
  "physics teacher",
  "pile-driver operator",
  "pipefitter",
  "pipelayer",
  "planing machine operator",
  "planning clerk",
  "plant operator",
  "plant scientist",
  "plasterer",
  "plastic patternmaker",
  "plastic worker",
  "plumber",
  "podiatrist",
  "police dispatcher",
  "police officer",
  "policy processing clerk",
  "political science teacher",
  "political scientist",
  "postal service clerk",
  "postal service mail carrier",
  "postal service mail processing machine operator",
  "postal service mail processor",
  "postal service mail sorter",
  "postmaster",
  "postsecondary teacher",
  "poultry cutter",
  "poultry trimmer",
  "power dispatcher",
  "power distributor",
  "power plant operator",
  "power tool repairer",
  "precious stone worker",
  "precision instrument repairer",
  "prepress technician",
  "preschool teacher",
  "priest",
  "print binding worker",
  "printing press operator",
  "private detective",
  "probation officer",
  "procurement clerk",
  "producer",
  "product promoter",
  "product manager",
  "production clerk",
  "production occupation",
  "proofreader",
  "property manager",
  "prosthetist",
  "prosthodontist",
  "psychiatric aide",
  "psychiatric technician",
  "psychiatrist",
  "psychologist",
  "psychology teacher",
  "public relations manager",
  "public relations specialist",
  "pump operator",
  "purchasing agent",
  "purchasing manager",
  "radiation therapist",
  "radio announcer",
  "radio equipment installer",
  "radio operator",
  "radiologic technician",
  "radiologic technologist",
  "rail car repairer",
  "rail transportation worker",
  "rail yard engineer",
  "rail-track laying equipment operator",
  "railroad brake operator",
  "railroad conductor",
  "railroad police",
  "rancher",
  "real estate appraiser",
  "real estate broker",
  "real estate manager",
  "real estate sales agent",
  "receiving clerk",
  "receptionist",
  "record clerk",
  "recreation teacher",
  "recreation worker",
  "recreational therapist",
  "recreational vehicle service technician",
  "recyclable material collector",
  "referee",
  "refractory materials repairer",
  "refrigeration installer",
  "refrigeration mechanic",
  "refuse collector",
  "regional planner",
  "registered nurse",
  "rehabilitation counselor",
  "reinforcing iron worker",
  "reinforcing rebar worker",
  "religion teacher",
  "religious activities director",
  "religious worker",
  "rental clerk",
  "repair worker",
  "reporter",
  "residential advisor",
  "resort desk clerk",
  "respiratory therapist",
  "respiratory therapy technician",
  "retail buyer",
  "retail salesperson",
  "revenue agent",
  "rigger",
  "rock splitter",
  "rolling machine tender",
  "roof bolter",
  "roofer",
  "rotary drill operator",
  "roustabout",
  "safe repairer",
  "sailor",
  "sales engineer",
  "sales manager",
  "sales representative",
  "sampler",
  "sawing machine operator",
  "scaler",
  "school bus driver",
  "school psychologist",
  "school social worker",
  "scout leader",
  "sculptor",
  "secondary education teacher",
  "secondary school teacher",
  "secretary",
  "securities sales agent",
  "security guard",
  "security system installer",
  "segmental paver",
  "self-enrichment education teacher",
  "semiconductor processor",
  "septic tank servicer",
  "set designer",
  "sewer pipe cleaner",
  "sewing machine operator",
  "shampooer",
  "shaper",
  "sheet metal worker",
  "sheriff's patrol officer",
  "ship captain",
  "ship engineer",
  "ship loader",
  "shipmate",
  "shipping clerk",
  "shoe machine operator",
  "shoe worker",
  "short order cook",
  "signal operator",
  "signal repairer",
  "singer",
  "ski patrol",
  "skincare specialist",
  "slaughterer",
  "slicing machine tender",
  "slot supervisor",
  "social science research assistant",
  "social sciences teacher",
  "social scientist",
  "social service assistant",
  "social service manager",
  "social work teacher",
  "social worker",
  "sociologist",
  "sociology teacher",
  "software developer",
  "software engineer",
  "soil scientist",
  "solderer",
  "sorter",
  "sound engineering technician",
  "space scientist",
  "special education teacher",
  "speech-language pathologist",
  "sports book runner",
  "sports entertainer",
  "sports performer",
  "stationary engineer",
  "statistical assistant",
  "statistician",
  "steamfitter",
  "stock clerk",
  "stock mover",
  "stonemason",
  "street vendor",
  "streetcar operator",
  "structural iron worker",
  "structural metal fabricator",
  "structural metal fitter",
  "structural steel worker",
  "stucco mason",
  "substance abuse counselor",
  "substance abuse social worker",
  "subway operator",
  "surfacing equipment operator",
  "surgeon",
  "surgical technologist",
  "survey researcher",
  "surveying technician",
  "surveyor",
  "switch operator",
  "switchboard operator",
  "tailor",
  "tamping equipment operator",
  "tank car loader",
  "taper",
  "tax collector",
  "tax examiner",
  "tax preparer",
  "taxi driver",
  "teacher assistant",
  "teacher",
  "team assembler",
  "technical writer",
  "telecommunications equipment installer",
  "telemarketer",
  "telephone operator",
  "television announcer",
  "teller",
  "terrazzo finisher",
  "terrazzo worker",
  "tester",
  "textile bleaching operator",
  "textile cutting machine setter",
  "textile knitting machine setter",
  "textile presser",
  "textile worker",
  "therapist",
  "ticket agent",
  "ticket taker",
  "tile setter",
  "timekeeping clerk",
  "timing device assembler",
  "tire builder",
  "tire changer",
  "tire repairer",
  "title abstractor",
  "title examiner",
  "title searcher",
  "tobacco roasting machine operator",
  "tool filer",
  "tool grinder",
  "tool maker",
  "tool sharpener",
  "tour guide",
  "tower equipment installer",
  "tower operator",
  "track switch repairer",
  "tractor operator",
  "tractor-trailer truck driver",
  "traffic clerk",
  "traffic technician",
  "training and development manager",
  "training and development specialist",
  "transit police",
  "translator",
  "transportation equipment painter",
  "transportation inspector",
  "transportation security screener",
  "transportation worker",
  "trapper",
  "travel agent",
  "travel clerk",
  "travel guide",
  "tree pruner",
  "tree trimmer",
  "trimmer",
  "truck loader",
  "truck mechanic",
  "tuner",
  "turning machine tool operator",
  "tutor",
  "typist",
  "umpire",
  "undertaker",
  "upholsterer",
  "urban planner",
  "usher",
  "UX designer",
  "valve installer",
  "vending machine servicer",
  "veterinarian",
  "veterinary assistant",
  "veterinary technician",
  "vocational counselor",
  "vocational education teacher",
  "waiter",
  "waitress",
  "watch repairer",
  "water treatment plant operator",
  "weaving machine setter",
  "web developer",
  "weigher",
  "welder",
  "wellhead pumper",
  "wholesale buyer",
  "wildlife biologist",
  "window trimmer",
  "wood patternmaker",
  "woodworker",
  "word processor",
  "writer",
  "yardmaster",
  "zoologist",
];

export const sample_staff_attendance_data = [
  {
    gym_name: "WTF Alpha Fitness Gym, Sector 49 Noida",
    gym_id: "nl0zlkFvIKOgm",
    trainers: [
      {
        user_id: "jd3a5JbR6uSAj",
        name: "Lalita  singh ",
        mobile: "8745808886",
        shift_details: [],
      },
      {
        user_id: "qR3OOpDzOhEYF",
        name: "Amal jose",
        mobile: "7529904404",
        shift_details: [
          {
            shift_id: "HpVAEseKQ1HfJ",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "14:01",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "00:01",
            },
          },
        ],
      },
      {
        user_id: "wO5VUAyarR9oX",
        name: "Azahruddin ",
        mobile: "9650232813",
        shift_details: [
          {
            shift_id: "0An9yVJcskUwA",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:56",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:04",
            },
          },
        ],
      },
      {
        user_id: "2jHEDzma1Fz9l",
        name: "Saurabh sharma",
        mobile: "9643272004",
        shift_details: [
          {
            shift_id: "Bx0PogAaKLz9w",
            start_time: "6:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "05:58",
              checkout_time: "14:05",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Early",
              shift_difference: "00:02",
            },
          },
        ],
      },
    ],
    receptionist: [
      {
        user_id: "WvXccTymTCjfg",
        name: "Hemant Chaudhary ",
        mobile: "8755672056",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "12:33",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "00:33",
            },
          },
        ],
      },
      {
        user_id: "meqPvK5e8nIdz",
        name: "Saurabh Saini",
        mobile: "8750010020",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "12:02",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "00:02",
            },
          },
        ],
      },
    ],
  },
  {
    gym_name: "WTF Exclusive Gym, Banashankari 3rd Stage Bangalore",
    gym_id: "O4t15nbwA8j2F",
    trainers: [
      {
        user_id: "PAsRARvTu6gXN",
        name: "Hemanth Kumar Y",
        mobile: "9148386114",
        shift_details: [
          {
            shift_id: "6KHxRRpUuGGDJ",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:55",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:05",
            },
          },
        ],
      },
      {
        user_id: "kEw9O0czziTQ4",
        name: "R.Harish Kumar ",
        mobile: "6362088217",
        shift_details: [
          {
            shift_id: "1qJjICA4fAbc2",
            start_time: "10:30",
            end_time: "18:30",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "10:30",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "On Time",
              shift_difference: "00:00",
            },
          },
        ],
      },
    ],
    receptionist: [
      {
        user_id: "Sk2H9fxHdJFFC",
        name: "wajid hussain",
        mobile: "7975371532",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Ongoing",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "6SlBa5D8ZIyqM",
        name: "Test Recp (Bangalore)",
        mobile: "8766661111",
        shift_details: [
          {
            shift_id: "vcPfhyQFMoPJZ",
            start_time: "10:00",
            end_time: "19:00",
            shift_name: "morning",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Ongoing",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
    ],
  },
  {
    gym_name: "WTF Exclusive Gym Gaur Mall, RDC Nagar Ghaziabad",
    gym_id: "i5WNQAW6UaBR7",
    trainers: [
      {
        user_id: "DDSUiax0VECRX",
        name: "Praveen Kumar ",
        mobile: "8791971194",
        shift_details: [
          {
            shift_id: "drMnGjyXIBGbO",
            start_time: "6:00",
            end_time: "10:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "06:05",
              checkout_time: "10:31",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Late",
              shift_difference: "00:05",
            },
          },
          {
            shift_id: "SNXEWZ6BWoAjR",
            start_time: "18:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Upcoming",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "lG1Nc3DCSgYmE",
        name: "Nitish yadav",
        mobile: "8448619244",
        shift_details: [
          {
            shift_id: "V256xEFO5z23m",
            start_time: "10:00",
            end_time: "18:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "11:08",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "01:08",
            },
          },
        ],
      },
    ],
    receptionist: [
      {
        user_id: "2X7ehh716l0bR",
        name: "Sandeep Verma ",
        mobile: "8799771722",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "11:59",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:01",
            },
          },
        ],
      },
    ],
  },
  {
    gym_name: "WTF Exclusive Gym, Niti Khand 1 Indirapuram",
    gym_id: "62rwOxI3Wwa4z",
    trainers: [
      {
        user_id: "rjyxndBKQs8Xx",
        name: "Abhishek Yadav ",
        mobile: "9625721585",
        shift_details: [
          {
            shift_id: "3cjMmX2J4Q7ML",
            start_time: "6:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "06:03",
              checkout_time: "14:01",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Late",
              shift_difference: "00:03",
            },
          },
        ],
      },
      {
        user_id: "qdxZN7ZnlHf6b",
        name: "Yogesh sharma ",
        mobile: "7982149505",
        shift_details: [
          {
            shift_id: "uN396gyjgRl0F",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:56",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:04",
            },
          },
        ],
      },
      {
        user_id: "Z9wecBG6PVR97",
        name: "Umang Tyagi",
        mobile: "8630329809",
        shift_details: [
          {
            shift_id: "27PClVmElFT4t",
            start_time: "6:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "05:57",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Early",
              shift_difference: "00:03",
            },
          },
        ],
      },
      {
        user_id: "8H9aXQNQYR25C",
        name: "Ashish kumar",
        mobile: "8368820895",
        shift_details: [
          {
            shift_id: "opWGxVYEYJIu0",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:59",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:01",
            },
          },
        ],
      },
    ],
    receptionist: [
      {
        user_id: "N0JGqCwkdVzrH",
        name: "Rajeev kumar Srivastav ",
        mobile: "9999427461",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "11:55",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:05",
            },
          },
        ],
      },
      {
        user_id: "C9is2OKE4pQbs",
        name: "kartik kumar",
        mobile: "8859389547",
        shift_details: [
          {
            shift_id: "poTRCtty",
            start_time: "06:00",
            end_time: "16:00",
            shift_name: "morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "07:53",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "01:53",
            },
          },
        ],
      },
    ],
  },
  {
    gym_name: "WTF Exclusive Gym, Sector 122 Noida",
    gym_id: "C0sy9EGGelPu7",
    trainers: [
      {
        user_id: "S0fw9yOUpIDUb",
        name: "Tabish Pasha ",
        mobile: "7906469776",
        shift_details: [
          {
            shift_id: "C2y1nZ6HPNefZ",
            start_time: "6:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "05:59",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Early",
              shift_difference: "00:01",
            },
          },
        ],
      },
      {
        user_id: "1lQVXFmCoM8A6",
        name: "Ajeet Kumar",
        mobile: "9891908646",
        shift_details: [
          {
            shift_id: "aWOyFlj0Om1Kf",
            start_time: "6:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "06:10",
              checkout_time: "14:55",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Late",
              shift_difference: "00:10",
            },
          },
        ],
      },
      {
        user_id: "w3Tojgh4NGbbx",
        name: "VIPIN SINGH ",
        mobile: "8800662131",
        shift_details: [
          {
            shift_id: "8ambZseFrhWd9",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:58",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:02",
            },
          },
        ],
      },
    ],
    receptionist: [
      {
        user_id: "gf8PLMxAlIPyY",
        name: "Harshit Shrivastav ",
        mobile: "9821834549",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Ongoing",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "SAMXPceTGDkjS",
        name: "Rahul Kumar",
        mobile: "8700348447",
        shift_details: [
          {
            shift_id: "poTRCtty",
            start_time: "06:00",
            end_time: "16:00",
            shift_name: "morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "07:56",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "01:56",
            },
          },
        ],
      },
      {
        user_id: "2np3mVtyCLTTN",
        name: "Rahul Garg",
        mobile: "9643045714",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "11:55",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:05",
            },
          },
        ],
      },
    ],
  },
  {
    gym_name: "WTF Exclusive Gym, Sector 7 Dwarka",
    gym_id: "nbSeuitHo80WA",
    trainers: [
      {
        user_id: "jcuF9dri9g50N",
        name: "Jayesh kumar",
        mobile: "8920148925",
        shift_details: [
          {
            shift_id: "Fzc34naRNE7GA",
            start_time: "6:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "06:07",
              checkout_time: "14:00",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Late",
              shift_difference: "00:07",
            },
          },
        ],
      },
      {
        user_id: "pgbKeDqJ0kOA5",
        name: "Shahrukh Khan ",
        mobile: "9560327641",
        shift_details: [
          {
            shift_id: "AtenYFF2PxZL4",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:59",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:01",
            },
          },
        ],
      },
      {
        user_id: "9a7Hgvp3K7XeJ",
        name: "Rishabh Chaudhary ",
        mobile: "8394001057",
        shift_details: [
          {
            shift_id: "dDObofZ9EGFMq",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:56",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:04",
            },
          },
        ],
      },
      {
        user_id: "ok66Hf92ZrWT9",
        name: "Ayush sohal",
        mobile: "9599649496",
        shift_details: [
          {
            shift_id: "VaBsRPM4IyMip",
            start_time: "6:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Past",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
    ],
    receptionist: [
      {
        user_id: "aSdGEDJbJxpqb",
        name: "Rajveer Singh ",
        mobile: "9015553635",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Ongoing",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "YWB9DatrDLPxo",
        name: "Rohit verma ",
        mobile: "8800148609",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "11:58",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:02",
            },
          },
        ],
      },
    ],
  },
  {
    gym_name: "WTF Exclusive Gym, WTT Tower Sector 16 Noida",
    gym_id: "uQu9T5e9YoRMC",
    trainers: [
      {
        user_id: "Tg7IucmlNFJNK",
        name: "sarfaraz ali ",
        mobile: "9810451134",
        shift_details: [
          {
            shift_id: "w9LelJmCZp9bk",
            start_time: "6:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Past",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "ma0mG1eLU7Pp9",
        name: "Tanmay ",
        mobile: "9289814581",
        shift_details: [
          {
            shift_id: "YPbDBXcYLhnYH",
            start_time: "16:00",
            end_time: "12:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Upcoming",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "fA241KnxdsGW6",
        name: "RUDRANSH SINGH ",
        mobile: "7042422920",
        shift_details: [
          {
            shift_id: "5cHsTX83wqIXr",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "14:03",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "00:03",
            },
          },
        ],
      },
      {
        user_id: "alkYVkHNISi50",
        name: "Rahul Awasthi ",
        mobile: "9839256181",
        shift_details: [
          {
            shift_id: "VXvcJ5m06I0yR",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:56",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:04",
            },
          },
        ],
      },
      {
        user_id: "Tt8q8ut0pTNU6",
        name: "Yash",
        mobile: "8076123462",
        shift_details: [
          {
            shift_id: "GydYEYPPrWM1K",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Ongoing",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "FWPfvUQ3fpm1p",
        name: "Raja",
        mobile: "9999492433",
        shift_details: [
          {
            shift_id: "vylCCkobfohOR",
            start_time: "6:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Past",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "7eLUwahg5SZa9",
        name: "WTT Trainer (Do No Delete)",
        mobile: "8528528528",
        shift_details: [
          {
            shift_id: "aSMpHMbgzoYTm",
            start_time: "12:55",
            end_time: "12:20",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Past",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
    ],
    receptionist: [
      {
        user_id: "BAz2vccd3e7j5",
        name: "Jitender Gautam ",
        mobile: "7042340010",
        shift_details: [
          {
            shift_id: "WERTG12we",
            start_time: "11:00",
            end_time: "21:00",
            shift_name: "morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "11:59",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "00:59",
            },
          },
        ],
      },
      {
        user_id: "vgOqPy28rzTO9",
        name: "Shweta Singh",
        mobile: "9953105935",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "12:03",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "00:03",
            },
          },
        ],
      },
      {
        user_id: "XTklZwCSNwPF9",
        name: "Gautam raha",
        mobile: "8800813109",
        shift_details: [
          {
            shift_id: "poTRCtty",
            start_time: "06:00",
            end_time: "16:00",
            shift_name: "morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "11:26",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "05:26",
            },
          },
        ],
      },
    ],
  },
  {
    gym_name: "WTF Metabolic Lifestyle Fitness Gym, Sector 10 Dwarka",
    gym_id: "zWKAF3ecJSzlF",
    trainers: [
      {
        user_id: "pzyF4s5fzq6aF",
        name: "Bilal",
        mobile: "9560402427",
        shift_details: [
          {
            shift_id: "vcSy0qWEYTqSW",
            start_time: "06:00",
            end_time: "11:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Past",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
          {
            shift_id: "0gWVkr6BB9ndJ",
            start_time: "17:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Upcoming",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "qtZTbj4krap6L",
        name: "Aftab Ansari ",
        mobile: "7827321052",
        shift_details: [
          {
            shift_id: "FbzB2k4wHkmSL",
            start_time: "6:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "06:11",
              checkout_time: "14:13",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Late",
              shift_difference: "00:11",
            },
          },
        ],
      },
      {
        user_id: "IGBBfgAh2jlVa",
        name: "Ashok Kumar ",
        mobile: "9990144735",
        shift_details: [
          {
            shift_id: "fqWRb7IdBV5Yf",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:57",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:03",
            },
          },
        ],
      },
    ],
    receptionist: [
      {
        user_id: "IBZM5mF81hb6V",
        name: "Chandan Yadav ",
        mobile: "8279479091",
        shift_details: [
          {
            shift_id: "mxmle8iGb6sgV",
            start_time: "08:00",
            end_time: "18:00",
            shift_name: "morning",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Ongoing",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "GZWMCDFFDVQ96",
        name: "Akshay jha",
        mobile: "7982224127",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "12:00",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "On Time",
              shift_difference: "00:00",
            },
          },
        ],
      },
    ],
  },
  {
    gym_name: "WTF Metabolic Lifestyle Fitness Gym, Sector 17 Dwarka",
    gym_id: "Su94CAfCLXf0t",
    trainers: [
      {
        user_id: "CBp3lrrR8FWbV",
        name: "Aakash arora ",
        mobile: "9354280768",
        shift_details: [
          {
            shift_id: "uWDdtz0Ugrs2P",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:56",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:04",
            },
          },
        ],
      },
      {
        user_id: "HhNjMUbzD3qKg",
        name: "Subhash jakhar",
        mobile: "9817538553",
        shift_details: [
          {
            shift_id: "H5Zd8oQvPwRoX",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:57",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:03",
            },
          },
        ],
      },
      {
        user_id: "S0RFbGkXY3bJx",
        name: "Shankar ",
        mobile: "9891208322",
        shift_details: [
          {
            shift_id: "e1dfX5oSrd0ks",
            start_time: "7:00",
            end_time: "15:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "06:56",
              checkout_time: "15:00",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Early",
              shift_difference: "00:04",
            },
          },
        ],
      },
    ],
    receptionist: [
      {
        user_id: "I6ObJH1mcVPfN",
        name: "Deepak solanki",
        mobile: "9953106729",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "11:57",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:03",
            },
          },
        ],
      },
      {
        user_id: "KEtA1zZgmqaLS",
        name: "Raj Kumar ",
        mobile: "9958906216",
        shift_details: [
          {
            shift_id: "poTRCtty",
            start_time: "06:00",
            end_time: "16:00",
            shift_name: "morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "07:48",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "01:48",
            },
          },
        ],
      },
    ],
  },
  {
    gym_name: "WTF Swear to Fit Fitness Club, Sector 70 Noida",
    gym_id: "qtoEygliTChVh",
    trainers: [
      {
        user_id: "R10PYhmwDEhaf",
        name: "Nikhil singh yadav",
        mobile: "8423532632",
        shift_details: [
          {
            shift_id: "A7eBzTNcORumn",
            start_time: "12:00",
            end_time: "21:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "12:05",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "00:05",
            },
          },
        ],
      },
      {
        user_id: "td3EvnhKKyji3",
        name: "Vinay Gill",
        mobile: "9996109601",
        shift_details: [
          {
            shift_id: "2OY6tixCHchIy",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Ongoing",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "sVDE7HpLbVy1m",
        name: "Kunal godiya",
        mobile: "9340064448",
        shift_details: [
          {
            shift_id: "sZfCAklwDA7zC",
            start_time: "6:00",
            end_time: "10:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "06:24",
              checkout_time: "10:38",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Late",
              shift_difference: "00:24",
            },
          },
          {
            shift_id: "ku3os6eEGIiQK",
            start_time: "18:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Not Checked-In",
              checkin_time: "N/A",
              checkout_time: "N/A",
              date: "N/A",
              shift_status: "Upcoming",
              status: "N/A",
              shift_difference: "N/A",
            },
          },
        ],
      },
      {
        user_id: "JGwrol4cCwtLL",
        name: "Bunty",
        mobile: "7417649990",
        shift_details: [
          {
            shift_id: "JMT5NEdHHTvAe",
            start_time: "14:00",
            end_time: "22:00",
            shift_name: "Evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "13:55",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Early",
              shift_difference: "00:05",
            },
          },
        ],
      },
      {
        user_id: "s44NRI88R1j71",
        name: "sunny ",
        mobile: "8700194922",
        shift_details: [
          {
            shift_id: "WXaLNvsbCEHgf",
            start_time: "06:00",
            end_time: "14:00",
            shift_name: "Morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "06:03",
              checkout_time: "14:54",
              date: "11-09-2024",
              shift_status: "Past",
              status: "Late",
              shift_difference: "00:03",
            },
          },
        ],
      },
    ],
    receptionist: [
      {
        user_id: "SqXnKDyUFAMbJ",
        name: "Sunny Gautam ",
        mobile: "8287565446",
        shift_details: [
          {
            shift_id: "eERTG12we",
            start_time: "12:00",
            end_time: "22:00",
            shift_name: "evening",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "12:05",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "00:05",
            },
          },
        ],
      },
      {
        user_id: "rYiuXUla1dK93",
        name: "Shahnawaj ali",
        mobile: "6306523466",
        shift_details: [
          {
            shift_id: "poTRCtty",
            start_time: "06:00",
            end_time: "16:00",
            shift_name: "morning",
            attendance_details: {
              checkin_status: "Checked-In",
              checkin_time: "07:46",
              checkout_time: "N/A",
              date: "11-09-2024",
              shift_status: "Ongoing",
              status: "Late",
              shift_difference: "01:46",
            },
          },
        ],
      },
    ],
  },
];
